import customerInspectorExclusions from "apis/customerInspectorExclusions";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";

export const addInspectorExclusion = (customerNumber, comment, inspectorNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {
    customerNumber,
    inspectorNumber,
    comment,
  },
  endpoint: customerInspectorExclusions.add(),
  successCallback,
  mountedRef
});

export const removeInspectorExclusion = (exclusionId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: customerInspectorExclusions.remove(exclusionId),
  successCallback,
  mountedRef
});

export const getInspectorExcludedCustomers = (inspectorNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: customerInspectorExclusions.getCustomers(inspectorNumber),
  successCallback,
  mountedRef
});

export const getExcludedInspectors = (customerNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: customerInspectorExclusions.getInspectors(customerNumber),
  successCallback,
  mountedRef
});